export default __webpack_public_path__ + "static/media/tasks-me-preview.dc820502.png";